var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5636",
    "data-name": "Group 5636",
    transform: "translate(-5002 -20539)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1993",
    "data-name": "Rectangle 1993",
    width: 70,
    height: 70,
    rx: 12.5,
    transform: "translate(5002 20539)",
    fill: "#e1e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "document",
    d: "M19.5,10.208V.671A10.175,10.175,0,0,1,23.095,2.99l5.081,5.084a10.141,10.141,0,0,1,2.32,3.593H20.958A1.458,1.458,0,0,1,19.5,10.208Zm11.667,5.082V27.708A7.3,7.3,0,0,1,23.875,35H9.292A7.3,7.3,0,0,1,2,27.708V7.292A7.3,7.3,0,0,1,9.292,0h6.584c.238,0,.472.019.707.035V10.208a4.375,4.375,0,0,0,4.375,4.375H31.132c.016.235.035.47.035.707ZM19.5,27.708a1.458,1.458,0,0,0-1.458-1.458H10.75a1.458,1.458,0,0,0,0,2.917h7.292A1.458,1.458,0,0,0,19.5,27.708Zm4.375-5.833a1.458,1.458,0,0,0-1.458-1.458H10.75a1.458,1.458,0,1,0,0,2.917H22.417A1.458,1.458,0,0,0,23.875,21.875Z",
    transform: "translate(5020.417 20556.5)",
    fill: "#e23744"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/PDFIcon.91a9908ea32b4d8e6daab50ea0f254fe.svg";
export { ForwardRef as ReactComponent };